import { Box, Dialog, DialogContent, Typography } from "@mui/material"
import { BoxFC, BoxFR } from "components/BoxCustom"
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import { alertError } from "components/Alert"
import dayjs from "dayjs"
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"

const columns = [{ field: "label", headerName: "พนักงานขับรถ", flex: 1 }]

// Create empty payroll งวด for drivers (IsActv=1, IsSub=0 — already applied to driverOnlyCombo)
// who don't yet have a payroll for the shown month. Multi-select then generatePayroll.
const AddPayrollDialog = ({ dialogOpen, setDialogOpen, exDrvIds, salDte, onFinish }) => {
  const { ax, msData } = useContext(GlobalStateContext)
  const [selectionModel, setSelectionModel] = useState([])

  const rows = useMemo(() => {
    const ex = new Set(exDrvIds || [])
    return msData.driverOnlyCombo.filter(d => !ex.has(d.id))
  }, [msData.driverOnlyCombo, exDrvIds])

  useEffect(() => { if (dialogOpen) setSelectionModel([]) }, [dialogOpen])

  const handleOk = useCallback(() => {
    if (selectionModel.length === 0) { alertError("กรุณาเลือกพนักงานขับรถ"); return }
    ax.post("/branch/driver-payroll-v3/generatePayroll", {
      DrvIds: selectionModel.map(Number), SalDte: dayjs(salDte).format("YYYY-MM-DD"),
    }).then(value => { if (value.data) { onFinish(value.data); setDialogOpen(false) } })
  }, [ax, selectionModel, salDte, onFinish, setDialogOpen])

  return (
    <Dialog open={dialogOpen} PaperComponent={PaperComponent} fullWidth maxWidth="sm">
      <DialogHeader handleDialogClose={() => setDialogOpen(false)} title="สร้างงวดเงินเดือน" onDeleteClick={null} />
      <DialogContent>
        <BoxFC pt={2} sx={{ height: 500 }}>
          <BoxFR>
            <Typography variant="body2">เดือน: <strong>{dayjs(salDte).format("MMMM YYYY")}</strong></Typography>
            <Box flex={1} />
            <Typography variant="body2" color="text.secondary">เลือก {selectionModel.length} คน</Typography>
          </BoxFR>
          <Box flex={1}>
            <DataGridCellExpand hideFooter density="compact" checkboxSelection
              rows={rows} columns={columns}
              selectionModel={selectionModel} onSelectionModelChange={ids => setSelectionModel(ids)} />
          </Box>
        </BoxFC>
      </DialogContent>
      <DialogFooter okText="สร้างงวด" handleDialogClose={() => setDialogOpen(false)} handleDialogOk={handleOk} />
    </Dialog>
  )
}

export default React.memo(AddPayrollDialog)
